import api from "./api";
import auth from "./auth";

export default {
  getOrdersDineInList({ page, params }) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v1/cms/dine-in/order-transactions/list/${page}`,
        params ? { ...params } : null,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getOrderDineInDetails(uuid) {
    return new Promise((resolve, reject) => {
      api.get(
        `estore-service/v1/cms/dine-in/order/transactions/details/${uuid}`,
        auth.getHeader()
      )
        .then((response) => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  }
}
